import { useState } from "react";
import { Chip, Tag } from "@/components/ui";
import { INDUSTRY_SAMPLES } from "./content";

/** Industry picker as scroll-snap pills, with the template's sample chips underneath. */
export function Industries() {
  const [active, setActive] = useState(INDUSTRY_SAMPLES[0]?.id ?? "");
  const sample = INDUSTRY_SAMPLES.find((s) => s.id === active) ?? INDUSTRY_SAMPLES[0];

  return (
    <section aria-labelledby="industries-title">
      <div className="mx-auto max-w-layout px-5 py-20">
        <h2 id="industries-title" className="wds-title-2 text-label-strong break-keep">
          업종마다 묻는 게 달라요
        </h2>
        <p className="mt-4 max-w-xl text-body-1 font-regular text-label-neutral break-keep">
          업종을 고르면 그에 맞는 칩과 질문이 깔려요. 사장님 가게에 맞게 켜고 끄거나 고쳐 쓰면 돼요.
        </p>

        <fieldset className="mt-8 min-w-0">
          <legend className="sr-only">업종 고르기</legend>
          <div className="tv-scroll-x -mx-5 flex snap-x snap-mandatory scroll-px-5 gap-2 overflow-x-auto px-5 pb-1">
            {INDUSTRY_SAMPLES.map((s) => (
              <Chip
                key={s.id}
                size="large"
                active={s.id === active}
                onClick={() => setActive(s.id)}
                className="snap-start"
              >
                {s.name}
              </Chip>
            ))}
          </div>
        </fieldset>

        {sample ? (
          <div
            aria-live="polite"
            className="mt-8 grid gap-8 rounded-xl bg-background-alternative p-6 sm:p-8 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]"
          >
            <div className="flex flex-col gap-6">
              <div>
                <h3 className="text-label-1 font-semibold text-label-neutral">좋았던 점 칩</h3>
                <ul className="mt-3 flex flex-wrap gap-2">
                  {sample.good.map((g) => (
                    <li key={g}>
                      <Tag color="primary">{g}</Tag>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-label-1 font-semibold text-label-neutral">아쉬웠던 점 칩</h3>
                <ul className="mt-3 flex flex-wrap gap-2">
                  {sample.bad.map((b) => (
                    <li key={b}>
                      <Tag>{b}</Tag>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div>
              <h3 className="text-label-1 font-semibold text-label-neutral">
                손님이 후기를 남기는 곳
              </h3>
              <ul className="mt-3 flex flex-col gap-2">
                {sample.places.map((p) => (
                  <li key={p} className="text-body-1 font-medium text-label-normal">
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
